import { Navigate, Outlet } from "react-router-dom";
import { useContextUsuario } from "../contexto/usuario/UsuarioContext";
import { mostraAlertaError } from "../componentes/alerts/sweetAlert";

export const AutenticacionRoute = ({ children }) => {
  const { token, usuario } = useContextUsuario();
  if (!token) {
    return <Navigate to="/login" />;
  }
  return <Outlet></Outlet>;
};